import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { connect } from 'general-store';
import { ETypes } from 'crm-events-data';
import { Map as ImmutableMap } from 'immutable';
import TimelineCard from './TimelineCard';
import TimelineMonthLabel from './TimelineMonthLabel';
import { PureComponent } from 'react';
import { Column } from 'foundations-components/transitional/components/Column';
import { ColumnWrapper } from 'foundations-components/transitional/components/ColumnWrapper';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import EngagementsStore from 'crm_data/engagements/EngagementsStore';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import EngagementRecord from 'customer-data-objects/engagement/EngagementRecord';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { isLoading, isEmpty, EMPTY, LOADING
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
} from 'crm_data/flux/LoadingStatus';
import { getCompactEventComponent } from '../../helpers/compactEventHelpers';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TimelinePinnedEngagement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shouldExpandPinnedEngagement: false
    };
  }
  componentDidUpdate(prevProps) {
    const isPinnedEngagementFromEmptyState = prevProps.pinnedEngagementId === EMPTY && this.props.pinnedEngagementId;
    const isPinnedEngagementReplaced = !!prevProps.pinnedEngagementId && prevProps.pinnedEngagementId !== this.props.pinnedEngagementId;
    if (isPinnedEngagementFromEmptyState || isPinnedEngagementReplaced) {
      this.setState({
        shouldExpandPinnedEngagement: true
      });
    }
  }
  getEngagementFormattedAsTimelineItem(engagement) {
    const timestamp = engagement.getIn(['engagement', 'timestamp']);
    const engagementId = engagement.getIn(['engagement', 'id']);
    return ImmutableMap({
      etype: ETypes.eventEngagement,
      id: `eventEngagement-${timestamp}-${engagementId}`,
      timestamp,
      eventData: engagement
    });
  }
  renderPinnedEngagement() {
    const {
      objectType,
      pinnedEngagement,
      subjectId
    } = this.props;
    const engagement = pinnedEngagement;
    const timelineItem = this.getEngagementFormattedAsTimelineItem(engagement);
    const EngagementComponent = getCompactEventComponent(timelineItem);
    if (!EngagementComponent) {
      return null;
    }
    return /*#__PURE__*/_jsx(TimelineCard, {
      isPinned: true,
      objectType: objectType,
      shouldExpandPinnedEngagement: this.state.shouldExpandPinnedEngagement,
      subjectId: subjectId,
      TimelineEventComponent: EngagementComponent,
      timelineItem: timelineItem
    });
  }
  renderSectionTitle() {
    return /*#__PURE__*/_jsx(ColumnWrapper, {
      "data-selenium-test": "timeline-pinned-engagement-title",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(Column, {
        children: /*#__PURE__*/_jsx(TimelineMonthLabel, {
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pinnedSection.title"
          })
        })
      })
    });
  }
  render() {
    if (!this.props.shouldDisplay || !this.props.pinnedEngagement) {
      return null;
    }
    return /*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: "0",
      as: "div",
      children: [this.renderSectionTitle(), this.renderPinnedEngagement()]
    });
  }
}
TimelinePinnedEngagement.propTypes = {
  objectType: AnyCrmObjectTypePropType.isRequired,
  pinnedEngagement: PropTypes.instanceOf(EngagementRecord),
  pinnedEngagementId: PropTypes.number,
  shouldDisplay: PropTypes.bool.isRequired,
  subjectId: PropTypes.string.isRequired
};
const dependencies = {
  pinnedEngagement: {
    stores: [EngagementsStore],
    propTypes: {
      pinnedEngagementId: PropTypes.number
    },
    deref({
      pinnedEngagementId
    }) {
      if (isLoading(pinnedEngagementId)) {
        return LOADING;
      }
      if (isEmpty(pinnedEngagementId)) {
        return EMPTY;
      }
      return EngagementsStore.get(pinnedEngagementId);
    }
  }
};
export default connect(dependencies)(TimelinePinnedEngagement);